import { Filter } from 'src/models/Filter';

import { FilterState } from './models';
import AppState from '../rootState';

const selectFilterState = (state: AppState): FilterState => state.filter;

export const selectFilterList = (state: AppState): Filter | null =>
  selectFilterState(state).filterList;
